// extracted by mini-css-extract-plugin
export default {"defaultStyle":"InquiryBannerComponent_defaultStyle_E1mbr"};